<template>
<div class="row border-bottom">
  <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
    <div class="navbar-header">
      <a href="javascript:;" class="navbar-minimalize minimalize-styl-2 btn btn-primary">
        <i class="fa fa-bars"></i>
      </a>
    </div>
    <ul class="nav navbar-top-links navbar-right">
      <li class="mr-3">
        <span class="label label-primary" style="color: black;">{{ version }}</span>
      </li>

      <li>
        <span class="m-r-sm text-muted">{{ user.name }}</span>
      </li>

      <!-- <li class="dropdown">
        <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
          <i class="fa fa-envelope"></i>
          <span class="label label-warning">16</span>
        </a>
        <ul class="dropdown-menu dropdown-messages">
          <li>
            <div class="dropdown-messages-box">
              <div class="media-body">
                <small class="pull-right">46h ago</small>
                <strong>Mike Loreipsum</strong> started following
                <strong>Monica Smith</strong>.
                <br>
                <small class="text-muted">3 days ago at 7:58 pm - 10.06.2014</small>
              </div>
            </div>
          </li>
          <li class="divider"></li>
          <li>
            <div class="dropdown-messages-box">
              <div class="media-body">
                <small class="pull-right text-navy">5h ago</small>
                <strong>Chris Johnatan Overtunk</strong> started following
                <strong>Monica Smith</strong>.
                <br>
                <small class="text-muted">Yesterday 1:21 pm - 11.06.2014</small>
              </div>
            </div>
          </li>
          <li class="divider"></li>
          <li>
            <div class="dropdown-messages-box">
              <div class="media-body">
                <small class="pull-right">23h ago</small>
                <strong>Monica Smith</strong> love
                <strong>Kim Smith</strong>.
                <br>
                <small class="text-muted">2 days ago at 2:30 am - 11.06.2014</small>
              </div>
            </div>
          </li>
          <li class="divider"></li>
          <li>
            <div class="text-center link-block">
              <a href="mailbox.html">
                <i class="fa fa-envelope"></i>
                <strong>Read All Messages</strong>
              </a>
            </div>
          </li>
        </ul>
      </li>
      <li class="dropdown">
        <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
          <i class="fa fa-bell"></i>
          <span class="label label-primary">8</span>
        </a>
        <ul class="dropdown-menu dropdown-alerts">
          <li>
            <a href="mailbox.html">
              <div>
                <i class="fa fa-envelope fa-fw"></i> You have 16 messages
                <span class="pull-right text-muted small">4 minutes ago</span>
              </div>
            </a>
          </li>
          <li class="divider"></li>
          <li>
            <a href="profile.html">
              <div>
                <i class="fa fa-twitter fa-fw"></i> 3 New Followers
                <span class="pull-right text-muted small">12 minutes ago</span>
              </div>
            </a>
          </li>
          <li class="divider"></li>
          <li>
            <a href="grid_options.html">
              <div>
                <i class="fa fa-upload fa-fw"></i> Server Rebooted
                <span class="pull-right text-muted small">4 minutes ago</span>
              </div>
            </a>
          </li>
          <li class="divider"></li>
          <li>
            <div class="text-center link-block">
              <a href="notifications.html">
                <strong>See All Alerts</strong>
                <i class="fa fa-angle-right"></i>
              </a>
            </div>
          </li>
        </ul>
      </li> -->

      <li>
        <a href="javascript:;" v-on:click="logout">
          <i class="fa fa-sign-out-alt"></i> {{ $t('logout') }}
        </a>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { version } from '../../../package.json'

export default {
  name: 'Topbar',
  data() {
    return {
      version
    }
  },
  computed: {
    ...mapState({
      user: state => state.session.user
    })
  },
  methods: {
    ...mapActions('session', ['logout'])
  },
  mounted() {
    // this.userName = session.getSession().name

    $('body').addClass('mini-navbar')

    $('.navbar-minimalize').on('click', function (event) {
      event.preventDefault()
      $('body').toggleClass('mini-navbar')
      SmoothlyMenu()
    })

    function SmoothlyMenu() {
      if ($('body').hasClass('body-small') || !$('body').hasClass('mini-navbar')) {
        //$('body').removeClass('mini-navbar')
        // Hide menu in order to smoothly turn on when maximize menu
        $('#side-menu').hide()
        // For smoothly turn on menu
        setTimeout(function () {
          $('#side-menu').show()
        }, 300)
      } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide()
        setTimeout(function () {
          $('#side-menu').fadeIn(400)
        }, 100)
      } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $('#side-menu').removeAttr('style')
      }
    }

  }
}
</script>
